import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Outlet } from 'react-router-dom';

// Layout & Components
import Header from './Component/NavBar/Header';
import ScrollToTop from './Component/TopScroll/ScrollToTop';

// Pages
import Home from './Pages/Home';
import MenProduct from './Pages/MenProduct';
import AboutUs from './Pages/AboutUs';
import Contact from './Pages/Contact';
import Account from "./Pages/Account";
import CheckOutPage from './Pages/CheckOutPage';
import SuccessPage from "./Pages/SuccessPage";
import FailedPage from './Pages/FailedPage';
import Order from './Component/OrderCom/Order';
import ReturnPolicy from './Pages/ReturnPolicy';
import Shipping from './Pages/Shipping';
import PrivacyPolicies from './Pages/PrivacyPolicies';
import TermsConditions from './Pages/TermsConditions';

// Auth & Product Details
import ForgotPassword from "./Component/account/ForgotPassword";
import DemoSignin from './Component/account/demoSignin';
import DemoProductDetails from './Component/ProductInfo/DemoProductDeatils.jsx';

// Layout wrappers for standard headers
const StandardLayout = () => (
  <>
    <Header />
    <Outlet />
  </>
);

const HeaderPropLayout = () => (
  <>
    <Header someProp={true} />
    <Outlet />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Standard Header Layout Routes */}
          <Route element={<StandardLayout />}>
            <Route path='/' element={<Home />} />
            <Route path='/:product_category' element={<MenProduct />} />
            <Route path='/about' element={<AboutUs />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/CheckOutPage' element={<CheckOutPage />} />
          </Route>

          {/* Header with `someProp={true}` Layout Routes */}
          <Route element={<HeaderPropLayout />}>
            <Route path='/:product_category/:product_subcategory/:slug' element={<DemoProductDetails />} />
            <Route path='/return-policy' element={<ReturnPolicy />} />
            <Route path='/shipping-policy' element={<Shipping />} />
            <Route path='/privacy-policies' element={<PrivacyPolicies />} />
            <Route path='/terms-conditions' element={<TermsConditions />} />
          </Route>

          {/* Standalone Routes (No Header) */}
          <Route path="/account/:page" element={<Account />} />
          <Route path="/account/demo" element={<DemoSignin />} />
          <Route path='/account/forgot-password' element={<ForgotPassword />} />
          <Route path='/order' element={<Order />} />
          <Route path='/order-success/:order_id' element={<SuccessPage />} />
          <Route path='/order-failed/:order_id' element={<FailedPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;